import { render, staticRenderFns } from "./downloadNewLabel.vue?vue&type=template&id=4e0b0ecc&scoped=true"
import script from "./downloadNewLabel.vue?vue&type=script&lang=js"
export * from "./downloadNewLabel.vue?vue&type=script&lang=js"
import style0 from "./downloadNewLabel.vue?vue&type=style&index=0&id=4e0b0ecc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0b0ecc",
  null
  
)

export default component.exports